import { CanDeactivateFn } from '@angular/router';

export const deactivateGuard: CanDeactivateFn<any> = (component) => {
  if (!component) return true;

  return component.canDeactivate ? component.canDeactivate() : true;
};
